
























import { replace } from "lodash";
import { Prop, Component, Vue } from "vue-property-decorator";
import TaskStatus from "./TaskStatus.vue";

export interface ListItem {
  id: number;
  projectId: number;
  projectName: string; // 現場
  task: string; // 工程
  status: string;
  operator: string; // 施工者
  client: string; // 発注者
  director: string; // 監督
  date: string; // 施工日
  _rowVariant?: string;
}

@Component({
  components: {
    TaskStatus
  }
})
export default class SearchTaskList extends Vue {
  @Prop({ default: () => [] }) items!: ListItem[];

  fields = [
    { key: "status", label: "" },
    { key: "date", label: "施工日" },
    { key: "task", label: "工程" },
    { key: "projectName", label: "現場名" },
    { key: "operator", label: "施工者" },
    { key: "client", label: "発注者" },
    { key: "director", label: "監督" }
  ];

  formatDate(date: string) {
    return replace(date, /-/g, "/");
  }
}
